// 通讯录
const contactsList = [
  {
    contactKey: 'contact',
    name: 'accountName',
    phone: 'accountPhone'
  },
  {
    contactKey: 'dfsdsd',
    name: 'wese',
    phone: 'dfdf'
  },
  {
    contactKey: 'vopfsjoi',
    name: 'dhfcb',
    phone: 'kjdfs'
  },
  {
    contactKey: 'shjdfhw',
    name: 'sada',
    phone: 'asdqw'
  },
  {
    contactKey: 'aeffs',
    name: 'qasd',
    phone: 'adff'
  },
  {
    contactKey: 'ofhyui',
    name: 'qjhvfd',
    phone: 'cjhj'
  },
  {
    contactKey: 'fgfss',
    name: 'dvs',
    phone: 'rgg'
  },
  {
    contactKey: 'fgdse',
    name: 'fsdf',
    phone: 'seww'
  },
  {
    contactKey: 'ohuis',
    name: 'lhjw',
    phone: 'ruvyf'
  },
  {
    contactKey: 'fgdwsa',
    name: 'gfgh',
    phone: 'cdfgf'
  },
  {
    contactKey: 'twsss',
    name: 'dfwew',
    phone: 'wefd'
  },
  {
    contactKey: 'sdwaas',
    name: 'qdasf',
    phone: 'dgss'
  },
  {
    contactKey: 'qsasds',
    name: 'awdws',
    phone: 'dweed'
  },
  {
    contactKey: 'swerwr',
    name: 'sdfwew',
    phone: 'dfsdvc'
  },
  {
    contactKey: 'sdfwee',
    name: 'sdwe',
    phone: 'rewws'
  },
  {
    contactKey: 'sfgthykg',
    name: 'fdsj',
    phone: 'fhjty'
  },
  {
    contactKey: 'hytrrbfg',
    name: 'ngrtd',
    phone: 'sdqwcvs'
  },
  {
    contactKey: 'rtuyetwe',
    name: 'sdfrhn',
    phone: 'drtert'
  },
  {
    contactKey: 'yhrte4wref',
    name: 'iuyth',
    phone: 'tjngfh'
  },
  {
    contactKey: 'iyujhgfhfgb',
    name: 'dfger',
    phone: 'dfva'
  },
  {
    contactKey: 'hfghrt',
    name: 'fghdfe',
    phone: 'dfgdfg'
  },
  {
    contactKey: 'lncdj',
    name: 'nincjdsk',
    phone: 'iwbchds'
  },
  {
    contactKey: 'qixngzfxjc',
    name: 'oyjtxrc',
    phone: 'xzwdvrjpk'
  },
  {
    contactKey: 'ghycyczd',
    name: 'sipcqi',
    phone: 'ngiyxf'
  }

]
// 好评弹框方法
const scoreFuncNameList = [
  'ufyisi',
  'sgewa',
  'aiwqhdf',
  'udhekb',
  'jekdd',
  'frezs',
  'ruhvia',
  'iojjhs',
  'wefssw',
  'swefsx',
  'aqeds',
  'aqerewe',
  'wesdfg',
  'olukgyh',
  'rerbfvbd',
  'jyhfghtyi',
  'uijnhgrt',
  'drtserutyhgf',
  'sdjfweor',
  'oabhcjd',
  'ktapxlpwmz',
  'rfofmf'
]
export { contactsList, scoreFuncNameList }
